export default "__VITE_ASSET__BRhH534e__"